import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, runTransaction } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBCEbIaRGXqPpQGA8GQgSbftDMPqUJSmUU",
  authDomain: "mygmtracker.firebaseapp.com",
  databaseURL: "https://mygmtracker-default-rtdb.firebaseio.com",
  projectId: "mygmtracker",
  storageBucket: "mygmtracker.firebasestorage.app",
  messagingSenderId: "628666364884",
  appId: "1:628666364884:web:0776c9c23efbb4d623dc41",
  measurementId: "G-8EM9G41XGG"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);
export default app;

export const getCurrentUser = () => auth.currentUser;

// ── Username uniqueness (Lot 2) ────────────────────────────────────
const USERNAME_REGEX = /^[a-zA-Z0-9_]{3,20}$/;

export function isValidUsernameFormat(username) {
  return USERNAME_REGEX.test(username || '');
}

// Vérif rapide non-transactionnelle, pour affichage live pendant la saisie
export async function checkUsernameAvailable(username, currentUid = null) {
  const { doc, getDoc } = await import('firebase/firestore');
  const key = (username || '').trim().toLowerCase();
  if (!isValidUsernameFormat(username)) return false;
  const snap = await getDoc(doc(db, 'usernames', key));
  if (!snap.exists()) return true;
  return currentUid ? snap.data().uid === currentUid : false;
}

// Claim atomique : gère à la fois l'inscription (oldUsername = null) et le changement (oldUsername fourni)
export async function claimUsername(uid, newUsername, oldUsername = null) {
  const newKey = (newUsername || '').trim().toLowerCase();
  const oldKey = oldUsername ? oldUsername.trim().toLowerCase() : null;

  if (!isValidUsernameFormat(newUsername)) {
    throw new Error('USERNAME_INVALID');
  }

  await runTransaction(db, async (tx) => {
    const { doc } = await import('firebase/firestore');
    const newRef = doc(db, 'usernames', newKey);
    const newSnap = await tx.get(newRef);

    if (newSnap.exists() && newSnap.data().uid !== uid) {
      throw new Error('USERNAME_TAKEN');
    }

    if (oldKey && oldKey !== newKey) {
      tx.delete(doc(db, 'usernames', oldKey));
    }

    tx.set(newRef, { uid, username: newUsername.trim() });
    tx.set(doc(db, 'users', uid), {
      username: newUsername.trim(),
      displayName: newUsername.trim(),
    }, { merge: true });
  });
}
